import {
  AVAILIBILITY,
  COLORS,
  IN_STOCK,
  OUT_OF_STOCK,
  PRICE,
  SIZES,
  VENDORS,
} from "../components/productListing/constants";
import { IsBrowser } from "../utils/isBrowser";

export function buildQuery(filter) {
  var query = [];
  Object.entries(filter).forEach(([key, values]) => {
    if (key !== "price") {
      return values.map((value) => {
        query.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
      });
    } else {
      if (values.min > 0) {
        query.push(
          encodeURIComponent(key) +
            "_min" +
            "=" +
            encodeURIComponent(values.min)
        );
      }
      if (values.max > 0) {
        query.push(
          encodeURIComponent(key) +
            "_max" +
            "=" +
            encodeURIComponent(values.max)
        );
      }
    }
  });

  let new_url = IsBrowser()
    ? window.location.pathname + (query.length ? "?" + query.join("&") : "")
    : "";

  return new_url;
}

export function RunFilter(products, filter) {
  var filteredProducts = products.filter(product => product.publishedInContext);
  Object.entries(filter).forEach(([key, values]) => {
    if (key === VENDORS && values.length > 0) {
      filteredProducts = filteredProducts.filter((product) =>
        values.includes(product.vendor)
      );
    } else if (key === AVAILIBILITY && values.length > 0) {
      var inStock = [];
      var outOfStock = [];
      if (values.includes(IN_STOCK)) {
        inStock = filteredProducts.filter((product) =>
          product.variants.some((variant) => variant.availableForSale === true)
        );
      }
      if (values.includes(OUT_OF_STOCK)) {
        outOfStock = filteredProducts.filter((product) =>
          product.variants.some((variant) => variant.availableForSale === false)
        );
      }

      filteredProducts = [...inStock, ...outOfStock];
      filteredProducts = filteredProducts.filter(
        (value, index, self) =>
          index ===
          self.findIndex((t) => t.id === value.id && t.title === value.title)
      );
    } else if (key === SIZES && values.length > 0) {
      filteredProducts = filteredProducts.filter((product) =>
        product.options
          .find((option) => option.name === "Size")
          ?.values.some((size) => values.includes(size))
      );
    } else if (key === COLORS && values.length > 0) {
      filteredProducts = filteredProducts.filter((product) =>
        product.options
          .find((option) => option.name === "Color")
          ?.values.some((color) => values.includes(color))
      );
    } else if (key === PRICE) {
      if (values.min > 0) {
        filteredProducts = filteredProducts.filter(
          (product) => product.priceRangeV2.minVariantPrice.amount >= values.min
        );
      }
      if (values.max > 0) {
        filteredProducts = filteredProducts.filter(
          (product) => product.priceRangeV2.maxVariantPrice.amount <= values.max
        );
      }
    }
  });
  return filteredProducts;
}

export function RunBundleFilter(products, filter) {
  let filteredProducts = products;
  Object.entries(filter).forEach(([key, values]) => {
    if (key === SIZES && values.length > 0) {
      filteredProducts = filteredProducts.filter((product) =>
          product.options
              .find((option) => option.name === "Size")
              ?.values.some((size) => values.includes(size))
      );
    } else if (key === COLORS && values.length > 0) {
      filteredProducts = filteredProducts.filter((product) =>
          product.options
              .find((option) => option.name === "Color")
              ?.values.some((color) => values.includes(color))
      );
    } else if (key === PRICE) {
      if (values.min > 0) {
        filteredProducts = filteredProducts.filter(
            (product) => parseFloat(product.bundle_price_nz.amount) >= values.min
        );
      }
      if (values.max > 0) {
        filteredProducts = filteredProducts.filter(
            (product) => parseFloat(product.bundle_price_nz.amount) <= values.max
        );
      }
    }
  });
  return filteredProducts;
}
